export const DISPLAY_TOAST = 'DISPLAY_TOAST'
export const AUTO_CLOSE_TOAST = 'AUTO_CLOSE_TOAST'
export const MANUAL_CLOSE_TOAST = 'MANUAL_CLOSE_TOAST'
